import { isValid, isDate, parse } from 'date-fns';
import { DATE_FORMAT_BACKEND_STRING } from './constants';
import { formatStarjackDateToBackendString } from './time';
// TODO: Move to guards
export const isOfTypeDate = (toBeDetermined) => isDate(toBeDetermined) && isValid(toBeDetermined);
export const getParsedObjectFromQuery = (query, includedKeys) => {
    const parsed = {};
    Object.entries(query).map(([key, value]) => {
        if (includedKeys.includes(key)) {
            // this condition is to avoid compiling errors due to string[]
            if (Array.isArray(value)) {
                parsed[key] = value;
                return;
            }
            else {
                const parsedDate = parse(value, DATE_FORMAT_BACKEND_STRING, new Date());
                if (isOfTypeDate(parsedDate)) {
                    parsed[key] = parsedDate;
                    return;
                }
                const parsedNumber = parseInt(value);
                if (!isNaN(parsedNumber)) {
                    parsed[key] = parsedNumber;
                }
                else {
                    parsed[key] = value;
                }
            }
        }
    });
    return parsed;
};
export const getSerializedObjectForQuery = (toSerialize, includedKeys = Object.keys(toSerialize)) => {
    const searchSerializable = {};
    for (const [key, value] of Object.entries(toSerialize)) {
        if (value !== undefined &&
            value !== null &&
            value !== '' &&
            includedKeys.includes(key)) {
            if (isOfTypeDate(value)) {
                const dateFormatted = formatStarjackDateToBackendString(value);
                if (dateFormatted) {
                    searchSerializable[key] = dateFormatted;
                }
            }
            else {
                searchSerializable[key] = value.toString();
            }
        }
    }
    return searchSerializable;
};
